import { IAlert } from '../models/alert.model';

import { IBaseAction } from './base.state';

export enum AlertActionTypes {
  OPEN_ALERT = 'ALERT.OPEN_ALERT',
  CLOSE_ALERT = 'ALERT.CLOSE_ALERT',
  VALIDATE_ACTION = 'ALERT.VALIDATE_ACTION',
}

export interface IOpenAlertAction extends IBaseAction {
  type: typeof AlertActionTypes.OPEN_ALERT;
  key: TAlertKey;
}

export interface ICloseAlertAction extends IBaseAction {
  type: typeof AlertActionTypes.CLOSE_ALERT;
  key: TAlertKey;
}

export interface IValidateAction extends IBaseAction {
  type: typeof AlertActionTypes.VALIDATE_ACTION;
  key: TAlertKey;
}

export type TAlertAction = IOpenAlertAction | ICloseAlertAction | IValidateAction;

export const AlertsKeys = [
  'userRootWarning',
  'userScopesWarning',
  'logoutWarning',
  'logoutReminder',
  'offlineWarning',
  'accessExpirationWarning',
] as const;
export type TAlertKey = (typeof AlertsKeys)[number];

export type TAlertState = Record<TAlertKey, IAlert>;
